import { useTranslation } from 'react-i18next';
import { Divider, MenuItem, Stack } from '@mui/material';
import { mdiDotsVertical } from '@mdi/js';

import { DropdownMenu } from 'common/components/DropdownMenu';
import { IconButton } from 'common/components/IconButton';

interface IProps {
    enablePortal?: boolean;
    isWebinarOrMeeting?: boolean;
    zIndex?: number;
    onClickEnroll?(): void;
    onClickReject?(): void;
    onClickDelete?(): void;
    onClickMail?(): void;
    onClickComplete?(): void;
    onClickCertificate?(): void;
    onSelect?: () => void;
}

export const EnrollmentsTableActions = ({
    enablePortal,
    isWebinarOrMeeting,
    zIndex,
    onClickEnroll,
    onClickReject,
    onClickDelete,
    onClickMail,
    onClickComplete,
    onClickCertificate,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <DropdownMenu
            anchor={
                <IconButton
                    aria-label={translate('actions')}
                    iconPath={mdiDotsVertical}
                    iconSize="2.4rem"
                    sx={{
                        width: '42px',
                        height: '42px',
                    }}
                />
            }
            enablePortal={enablePortal}
            placement="bottom-end"
            sx={{ zIndex }}
        >
            <Stack divider={<Divider sx={{ my: 1.25 }} />}>
                {(isWebinarOrMeeting || onClickDelete) && (
                    <>
                        {isWebinarOrMeeting && (
                            <>
                                {onClickEnroll && (
                                    <MenuItem
                                        tabIndex={0}
                                        onClick={onClickEnroll}
                                    >
                                        {translate('enrollmentsTable.enroll')}
                                    </MenuItem>
                                )}

                                {onClickReject && (
                                    <MenuItem
                                        tabIndex={0}
                                        onClick={onClickReject}
                                    >
                                        {translate('enrollmentsTable.reject')}
                                    </MenuItem>
                                )}
                            </>
                        )}

                        {onClickDelete && (
                            <MenuItem tabIndex={0} onClick={onClickDelete}>
                                {translate('enrollmentsTable.delete')}
                            </MenuItem>
                        )}
                    </>
                )}

                {onClickMail && (
                    <>
                        <MenuItem tabIndex={0} onClick={onClickMail}>
                            {translate('enrollmentsTable.sendMail')}
                        </MenuItem>
                    </>
                )}

                {isWebinarOrMeeting &&
                    (onClickComplete || onClickCertificate) && (
                        <>
                            {onClickComplete && (
                                <MenuItem
                                    tabIndex={0}
                                    onClick={onClickComplete}
                                >
                                    {translate('enrollmentsTable.complete')}
                                </MenuItem>
                            )}

                            {onClickCertificate && (
                                <MenuItem
                                    tabIndex={0}
                                    onClick={onClickCertificate}
                                >
                                    {translate(
                                        'enrollmentsTable.createCertificate'
                                    )}
                                </MenuItem>
                            )}
                        </>
                    )}
            </Stack>
        </DropdownMenu>
    );
};
